import styled, { keyframes } from "styled-components";

import { SimpleUserInitialsNameContainer } from "shared/components/atoms/SimpleUserInitials/styles";

interface ICircularProgressProps {
  progressRate: number;
}

export const CircularProgress = styled.div<ICircularProgressProps>`
  display: flex;

  .circular-progress {
    --size: 110px;
    --half-size: calc(var(--size) / 2);
    --stroke-width: 5px;
    --radius: calc((var(--size) - var(--stroke-width)) / 2);
    --circumference: calc(var(--radius) * pi * 2);
    --dash: calc((var(--progress) * var(--circumference)) / 100);
    --stroke-color: #f2c34a;
    --transition: stroke-dasharray 0.5s linear 0s;

    animation: complete-level 0.2s linear 0s 1 forwards,
      reset-instant 0s linear 0.8s forwards,
      progress-animation 1s linear 0.9s forwards;
  }

  .circular-progress circle {
    cx: var(--half-size);
    cy: var(--half-size);
    r: var(--radius);
    stroke-width: var(--stroke-width);
    fill: none;
  }

  .circular-progress circle.bg {
    stroke: ${({ theme }) => (theme.mode === "dark" ? "#444445" : "#dbdada")};
  }

  .circular-progress circle.fg {
    transform: rotate(-90deg);
    transform-origin: var(--half-size) var(--half-size);
    stroke-dasharray: var(--dash) calc(var(--circumference) - var(--dash));
    transition: var(--transition);
    stroke: var(--stroke-color);
  }

  @property --progress {
    syntax: "<number>";
    inherits: false;
    initial-value: 0;
  }

  @keyframes complete-level {
    from {
      --progress: 0;
    }
    to {
      --progress: 100;
    }
  }

  @keyframes reset-instant {
    100% {
      --stroke-color: ${({ theme }) =>
        theme.mode === "dark" ? "#444445" : "#dbdada"};
      --progress: 0;
      --transition: stroke-dasharray 0s linear 0s;
    }
  }

  @keyframes progress-animation {
    from {
      --progress: 0;
      --stroke-color: #f2c34a;
      --transition: stroke-dasharray 0.5s linear 0s;
    }

    to {
      --stroke-color: #f2c34a;
      --progress: ${({ progressRate }) => progressRate};
    }
  }
`;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px); 
  }
  to {
    opacity: 1;
    transform: translateY(0); 
  }
`;

export const GamificationModalUserPhotoContainer = styled.div`
  margin-bottom: 24px;

  .user-photo {
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-areas: "content";

    ${CircularProgress} {
      z-index: 1;
      justify-content: center;
    }

    > div {
      grid-area: content;
    }
  }

  .user-photo:has(${CircularProgress}) .user-info {
    gap: 10px;
  }

  .user-info {
    display: flex;
    align-items: flex-end;

    :not(:has(svg)) {
      display: flex;
      justify-content: center;
    }

    img,
    ${SimpleUserInitialsNameContainer} {
      display: flex;
      align-items: flex-end;

      .right-starts-icon {
        position: relative;
        top: -10px;
      }
    }

    ${SimpleUserInitialsNameContainer} {
      width: 88px;
      height: 88px;

      align-items: center;
      justify-content: center;
    }

    .right-starts-icon,
    .left-starts-icon {
      opacity: 0;
      transition: 0.3s all;
    }

    img {
      border-radius: 50%;
    }

    .right-starts-icon {
      position: relative;
      top: -10px;

      animation: ${fadeInUp} 0.3s ease-out forwards;
      animation-delay: 0.8s;
    }

    .left-starts-icon {
      animation: ${fadeInUp} 0.3s ease-out forwards;
      animation-delay: 0.8s;
    }
  }
`;
